import { Observable } from 'rxjs';
import { Subscription } from './model';
import { Plan } from './model'; // Assuming Plan is also defined in model.ts

export abstract class SubscriptionRepository {
  abstract createSubscription(subscriptionData: Partial<Subscription>): Observable<Subscription>;
  abstract getSubscriptions(page: number, limit: number): Observable<Subscription[]>;
  abstract updateSubscription(id: number, subscriptionData: Partial<Subscription>): Observable<Subscription>;
  abstract cancelSubscription(id: number): Observable<void>;

  // Methods to fetch plans
  abstract getSubscription(): Observable<Subscription>;
  abstract getPlans(): Observable<Plan[]>;
  abstract getPlan(id: number): Observable<Plan>;
  abstract associateSubscription(data: any): Observable<any>;
  abstract upgradeSubscription(planId: number): Observable<any>;
}
